import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiViewComponent.vue?vue&type=template&id=c6a0bd52"
import script from "./RasConfigurazionePostiLettoPianiViewComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports